// カテゴリ × 時間帯ヒートマップ（売上）
import type { CategoryHourCell } from '../../lib/salesAnalytics';

interface Props {
  cells: CategoryHourCell[];
  categories: string[];
  hours: number[];
}

export const CategoryHourGrid = ({ cells, categories, hours }: Props) => {
  const max = Math.max(...cells.map((c) => c.sales), 1);
  const lookup = new Map<string, number>();
  for (const c of cells) lookup.set(`${c.category}|${c.hour}`, c.sales);

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: 11 }}>
        <thead>
          <tr>
            <th style={{ ...th, minWidth: 110, textAlign: 'left' }}>カテゴリ</th>
            {hours.map((h) => (
              <th key={h} style={{ ...th, minWidth: 36, textAlign: 'center' }}>
                {h}時
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {categories.map((cat) => (
            <tr key={cat}>
              <th style={{ ...th, textAlign: 'left', background: '#f8f9fa' }}>{cat}</th>
              {hours.map((h) => {
                const v = lookup.get(`${cat}|${h}`) ?? 0;
                const ratio = v / max;
                const bg = v > 0 ? `rgba(28,126,214,${0.08 + ratio * 0.85})` : '#f8f9fa';
                const color = ratio > 0.55 ? '#fff' : '#212529';
                return (
                  <td
                    key={h}
                    style={{
                      ...td,
                      background: bg,
                      color,
                      textAlign: 'center',
                      minWidth: 36,
                    }}
                    title={`${cat} ${h}時 / ¥${v.toLocaleString()}`}
                  >
                    {v > 0 ? Math.round(v / 1000) + 'k' : ''}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const th: React.CSSProperties = {
  padding: '2px 4px',
  border: '1px solid #f1f3f5',
  fontWeight: 600,
  color: '#495057',
};
const td: React.CSSProperties = {
  padding: '4px 6px',
  border: '1px solid #f1f3f5',
};
